import { createFileRoute } from "@tanstack/react-router";
import { useEffect, useState } from "react";
import { useAuth } from "@/lib/auth";
import { db } from "@/lib/data";
import { PageHeader } from "@/components/shared/Primitives";
export const Route = createFileRoute("/portal/wishlist")({ component: Page });
function Page() {
  const { user } = useAuth(),
    [r, setR] = useState([]);
  useEffect(() => {
    if (user) db.wishlist(user.id).then(setR);
  }, [user]);
  return (
    <div className="space-y-6">
      <PageHeader title="Wishlist" description="Saved products." />
      <div className="grid gap-3 md:grid-cols-3">
        {r.map((x: any) => (
          <div
            key={x.product_id}
            className="rounded-2xl border border-border bg-card p-5"
          >
            <b>{x.products?.display_name || x.products?.name}</b>
            <p>
              ₹{Number(x.products?.retail_price || 0).toLocaleString("en-IN")}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
}
